import React from 'react';
import { useIntl } from 'react-intl'; // Using hook instead of HOC
import { Button } from 'react-bootstrap';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import FormInput from 'components/forms/FormInput';
import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';

import RichEditorContent from 'components/RichEditorContent';

function CmsElementNewsletter(props) {
  const { editMode, index, showElementSettings } = props;

  const { formatMessage, messages } = useIntl();

  // CMS Logic via Hook (replaces AbstractCmsElement class logic)
  const {
    shown,
    setShown,
    getMainId,
    getCustomId,
    getParamValue,
    getBackgroundStyle,
    elementStyleTag,
    getParallaxData,
    getAppendHtml,
    cssClasses,
    responsiveClasses,
  } = useAbstractCmsElement(props);

  // dnd-kit Sortable Hook
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: index,
    disabled: !editMode,
  });

  // Drag and drop styles
  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
    position: 'relative',
    width: '100%',
    cursor: editMode ? 'move' : 'default',
  };

  // UI Constants
  const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';
  const textAlign = getParamValue('textAlign', 'center');
  const mainColor = getParamValue('mainColor', 'master');

  const innerContent = (
    <div
      id={getMainId()}
      className={`ms-newsletter ${shownClass} ${cssClasses} ${responsiveClasses}`}
      onClick={(e) => editMode && showElementSettings(e, index)}
      style={getBackgroundStyle()}
    >
      {/* Dynamic styles tag for custom animations/CSS */}
      {elementStyleTag}

      <div className={`ms-newsletter-container text-${textAlign} text-${mainColor}`}>
        <h2 className="no-margin p-b-25">{getParamValue('title', '')}</h2>

        <RichEditorContent content={'<p>' + getParamValue('content', '') + '</p>'} />

        <FormInput name="email" label={messages.email} type="email" style={{ display: 'initial', width: '250px' }} />

        <div className="text-right">
          <Button
            className="call-to-action btn-animated from-left fa fa-arrow-right"
            variant="primary"
            // Note: onClick logic for subscription would be added here
          >
            <span>{messages.subscribe}</span>
          </Button>
        </div>
      </div>

      {getAppendHtml()}
    </div>
  );

  const parallaxData = getParallaxData();

  return (
    <div ref={setNodeRef} style={dndStyle} {...attributes} {...listeners}>
      {/*
          Stable wrapper for ScrollTrigger (React 19 Fix).
          Prevents measurement errors of the DOM node.
      */}
      <div>
        <CustomScrollTrigger className="cms-overflow-fix" onEnter={() => setShown(true)} {...getCustomId()}>
          {parallaxData ? (
            <Parallax {...parallaxData}>
              {innerContent}
            </Parallax>
          ) : (
            innerContent
          )}
        </CustomScrollTrigger>
      </div>
    </div>
  );
}

export default CmsElementNewsletter;
